import { createContext } from 'react';
import { useFortiCloud } from 'hooks/useFortiCloud';
import { FortiCloudData } from 'common/types/forticloud';

export const FortiCloudContext = createContext<{
  isLoading: boolean;
  fortiCloudData: FortiCloudData | undefined;
  refetch: () => Promise<Record<string, any>>;
}>({
  isLoading: false,
  refetch: undefined,
  fortiCloudData: undefined,
});

export const FortiCloudProvider = ({ children }: { children: JSX.Element }) => {
  const { isLoading, refetch, data: fortiCloudData } = useFortiCloud();

  return (
    <FortiCloudContext.Provider
      value={{
        refetch,
        isLoading,
        fortiCloudData,
      }}
    >
      {children}
    </FortiCloudContext.Provider>
  );
};
